import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getPriorArt } from '../../api/inventionDisclosure/inventionDisclosure';
import { GetPriorArtPayload } from '../../api/inventionDisclosure/types';

export const fetchAllPriorArt = createAsyncThunk(
  'priorArtPatents/getAll',
  async (payload: GetPriorArtPayload, { rejectWithValue }) => {
    try {
      const payloadObj = {
        inventionDisclosureId: payload.inventionDisclosureId,
        pageNum: payload.pageNum,
      };

      return await getPriorArt(payloadObj);
    } catch (err) {
      const error: AxiosError = err as AxiosError;

      return rejectWithValue({
        error: error.response?.data ? error.response?.data : 'Oops.. something went wrong',
      });
    }
  },
);
